import Projection, { TSIZE } from './projection';
import { TILES_BASE_URI } from '../../config/constants';

export default class SimpleProjection extends Projection {
  constructor(diagram) {
    super();
    this.diagram = diagram;
  }

  async init() {
    let response = await fetch(`${TILES_BASE_URI}/diagrams/${this.diagram}/metadata.json`);
    if (response.ok) {
      this.metadata = await response.json();
    }
  }

  project(y, x) {
    return [x / TSIZE, -y / TSIZE];
  }

  pointZoom() {
    return Math.max(
      Math.min(1, this.metadata.max_zoom_level),
      this.metadata.min_zoom_level
    );
  }

  tilesAtZoom(zoom) {
    let [x0, y0, x1, y1] = this.metadata.zoom_levels[zoom];
    return [x1 - x0, y1 - y0];
  }

  tileCoord(i, j, zoom) {
    return [
      i * TSIZE,
      j * TSIZE
    ];
  }

  tileUrl(z, x, y) {
    return `${TILES_BASE_URI}/diagrams/${this.diagram}/tiles/${z}/${y}/${x}/tile.png`; }
}
